/**
 * A booking draft must survive an involuntary compliance detour.
 *
 * BookingLayout resets the booking store when the /booking stack unmounts, to
 * clear the draft on a genuine exit — swipe-back, browser-back, walking away.
 * But a compliance gate (KYC or AML) redirecting a guest OUT of checkout to
 * finish a declaration also unmounts that stack, and that is not an exit: the
 * guest is being sent to do one thing and will come straight back. Resetting
 * there wiped their dates, times, delivery locations and promo, so they returned
 * to an empty form after doing exactly what the app told them to.
 *
 * This one-shot flag distinguishes the two. A gate marks the detour immediately
 * before it redirects; the layout consumes the flag on unmount and skips the
 * reset exactly once. A real exit never sets it, so a real exit still resets.
 *
 * A plain module boolean rather than a store field: it is navigation-transient,
 * never rendered, and must not be persisted — a detour flag that outlived the
 * process would suppress a legitimate reset on the next launch.
 */
let detouring = false

/** Called by a gate just before it redirects out of the booking stack. */
export function markBookingComplianceDetour(): void {
  detouring = true
}

/**
 * Read and clear the flag. Returns true when the pending unmount is a compliance
 * detour (so the caller should NOT reset the draft), false for a genuine exit.
 */
export function consumeBookingComplianceDetour(): boolean {
  const wasDetour = detouring
  detouring = false
  return wasDetour
}
